var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('userList',{attrs:{"customer":_vm.id}}),_c('div',{staticStyle:{"grid-row-start":"span 2"}},[_c('el-empty',{attrs:{"title":"暂无数据"}})],1),_c('manList',{attrs:{"customer":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }